<template>
    <div class="panel">
        <div class="head">
            <span class="title">单位分组管理</span>
            <button class="add-group-btn" @click="addNode"><i class="fa fa-plus icon-plus"></i>添加根节点</button>
            <span style="clear: both"></span>
        </div>
        <div class="group-list" v-if="pageAuth===true">
            <Spin v-if="pageLoading" fix size="large"></Spin>
            <Tree ref="listTree" :data="list" :indent="50" draggable crossTree>
                <div slot-scope="{data,store}" class="group-one" title="拖拽移动">
                    <span class="group-id" v-if="data.id !==''">
                        ID {{data.id}}
                    </span>
                    <span class="group-id" v-else>
                        ID {{data.id}}
                    </span>
                    <Input v-model="data.name" placeholder="请填写分组名称" :style="{width:'200px',padding:'0'}"></Input>
                    <Input v-model="data.display_order" placeholder="请填写排序" :style="{width:'80px',padding:'0'}"></Input>

                    <span class="group-id group-one-btn" @click="deleteNode(data)">删除</span>
                    <span class="group-id group-one-btn" @click="addChild(data)" >添加</span>
                </div>
            </Tree>
        </div>

        <Button type="primary" @click="saveGroup" :loading="loadingStatus" style="width: 150px;margin-top: 50px;">保存</Button>
    </div>


</template>

<script>
    import baseAuthEnum from "@/staticData/baseAuthEnum";
    import {DraggableTree} from 'vue-draggable-nested-tree';
    import utils from "@/utils";
    import $api from "@/service";

    export default {
        components: {
            Tree: DraggableTree
        },
        data () {
            return {
                //节点数据
                list : [
                    // {id: '1',name:"后勤部",display_order:"1"},
                    // {id: '2',name:"监控室",display_order:"1"},
                    // {id: '3',name:"网络运营事业部",display_order:"1", children: [
                    //         {id: '4 ',name:"研发部",display_order:"1",  children: [
                    //             {id: '3',name:"PHP",display_order:"1"},
                    //             {id: '5',name:"前端",display_order:"1"},
                    //         ]},
                    //         {id: '6',name:"产品部",display_order:"1"},
                    //     ]},
                ],
                //权限
                pageAuth : false,
                loadingStatus : false,
                pageLoading : true,
                checkStatus : true, //表单验证字段
            }
        },
        created(){
            this.getPageAuth();
            this.getList();
        },
        methods:{
            //获取权限
            getPageAuth(){
                this.pageAuth = utils.judgeAuth([baseAuthEnum.EDIT_COMPANY_GROUP],1);
            },
            //获取数据并整理格式
            getList(){
                let _self = this;
                this.pageLoading = true;
                $api.getCompanyGroupList().then(data=>{
                    _self.pageLoading = false;
                    if(!data || data.length <= 0){
                        _self.list =  [];
                        return false;
                    }else{
                        //整理格式
                        _self.list = _self.changeListTreeData(data,"0");
                    }
                });
            },
            /**
             * 将数据整理成层级结构
             * @param {array} list 待整理的数据
             * @param {string} fid 父级id
             * @returns {array}
             */
            changeListTreeData(list,fid){
                let items = {};
                for(let i = 0; i < list.length;i++){
                    let key = list[i].fid;
                    if(!items[key]){
                        items[key] = [];
                        items[key].push(list[i]);
                    }else{
                        items[key].push(list[i]);
                    }
                }
                return this.formatTree(items,fid);
            },
            /**
             * 递归搞数据,简单地说就是一维数组->Tree结构[不过慎用递归，递归次数过载会造成内存爆破]
             * @param {object} items 待调整的数据
             * @param {string} fid 父级id
             * @returns {Array}
             */
            formatTree(items,fid){
                let result = [];
                if(items[fid] === [] || !items[fid]){
                    return result;
                }
                for (let t of items[fid]){
                    t.children = this.formatTree(items,t.id);
                    result.push(t);
                }
                return result;
            },
            /**
             * 将层级结构解成一纬度的数组
             * @param {object} data 待处理的数据
             * @returns {array}
             */
            restoreTreeDataList(data){
                this.checkStatus = true;
                return this.formatList(data);
            },
            /**
             * Tree->List[解Tree结构，再次申明，少用递归]
             * @param {object} datas 待处理的数据
             * @param {string} fid 父级id
             * @returns {Array}
             */
            formatList(datas,fid){
                let res = [];
                for(let data of datas){
                    res.push({
                        "id"    :   data.id,
                        "name"  :   data.name,
                        "fid"   :   fid ? fid : "",
                        display_order : data.display_order,
                    });
                    //验证单位分组名必填
                    if(!data.name.trim()){
                        this.checkStatus = false;
                    }
                    if(!(!data.children || data.children.length <= 0)){
                        res = res.concat(this.formatList(data.children,data.id));
                    }
                }
                return res;
            },
            //增加根节点
            addNode(){
                this.list.unshift({id:"",name:"",display_order:"",children:[]});
            },
            /**
             * 增加子节点
             * @param {object} data 父节点对象
             */
            addChild(data){
                data.children.unshift({id:"",name:"",display_order:"",children:[]});
            },
            /**
             * 删除节点
             * @param {object} node 待删除节点对象
             * @returns {boolean}
             */
            deleteNode(node){
                let index = node.parent.children.indexOf(node);
                if(index < 0){
                    return false;
                }
                if(node.id === ""){
                    node.parent.children.splice(index,1);
                }else{
                    //查询删除的部门节点下是否还有人
                    $api.findGroupUsers(node.id).then(data=>{
                        if(data.code === "200"){
                            if(data.data.is_have === "2"){
                                //不存在用户
                                node.parent.children.splice(index,1);
                            }else{
                               //存在用户
                               utils.notice("请先转移该单位分组或其下级分组中的用户","error");
                            }
                        }else{
                            utils.notice(data.msg,"error");
                        }
                    });
                }

            },
            //保存按钮
            saveGroup(){
                //权限验证
                if(this.pageAuth === false){
                    return false;
                }

                let list = this.list;
                let arr = [];
                let ids = [];
                //整理结果[这步操作用来获取新旧id的变化，以减少后端开发难度]
                if(list && list.length > 0){
                    arr = this.restoreTreeDataList(list);
                }
                if(!this.checkStatus){
                    utils.notice("请填写分组名称","warning");
                    return false;
                }
                for(let i = 0 ; i < arr.length ; i ++){
                    if(!(!arr[i].id || arr[i].id === "")){
                        ids.push(arr[i].id);
                    }
                }

                let res = [];
                res = this.$refs.listTree.getPureData();

                let postData = {
                    "ids" : ids,
                    "list": res,
                };
                //axios
                let _self = this;
                this.loadingStatus = true;
                $api.setCompanyGroupList(postData).then(data=>{
                    _self.loadingStatus = false;
                    if(data.code === "200"){
                        utils.message({title: "保存成功"}, 'success');
                        _self.getList();
                    }else{
                        utils.message({title: data.msg}, 'error');
                    }
                });
            }
        }
    }
</script>

<style scoped>
@import "index.less";
</style>


// WEBPACK FOOTER //
// src/pages/company/group/Index.vue